//Agency Build Form
import shortid from 'shortid';
const staticData = [
  {
    documentURL:
      'https://pgformbuilder.blob.core.windows.net/forms/ASamplePDF_2020-05-13-13-09-55.pdf',
    elements: [],
  },
  {
    documentURL:
      'https://pgformbuilder.blob.core.windows.net/forms/dummy_2020-05-13-13-09-56.pdf',
    elements: [
      {
        elementId: 1,
        documentIndex: 1,
        xCord: 153,
        yCord: 272,
        placeholder: 'Name',
        propertyType: 'Checkbox',
        fontSize: '12',
        justify: 'Left',
        isBold: false,
        imgWidth: '100',
        imgHeight: '100',
        textValue: '',
        imageValue: '',
        checkboxType: 'Cross',
        checkboxSize: 'Small',
        checkboxValue: true,
      },
      {
        elementId: 2,
        documentIndex: 1,
        xCord: 250,
        yCord: 250,
        placeholder: 'Photo',
        propertyType: 'Image',
        fontSize: '12',
        justify: 'Left',
        isBold: false,
        imgWidth: '100',
        imgHeight: '100',
        textValue: '',
        imageValue: '',
      },
    ],
  },
  {
    documentURL:
      'https://pgformbuilder.blob.core.windows.net/forms/pdf-test_2020-05-13-16-43-24.pdf',
    elements: [],
  },
];

const initialDocument = {
  documentURL: '',
  elements: [],
};

// agencyServiceId:'',
export const initialRequiredDocument = {
  documentId: shortid.generate(),
  documentName: '',
  description: '',
};

// Form Initial Values
const formInitialValues = {
  serviceName: '',
  serviceDescription: '',
  serviceDomainURL: '',
  serviceAmount: '',
  paymentType: '',
  documentType: '',
  locationCodeId: '',
};
export const createDocumentFormInitialValues = {
  currentStep: 1,
  agencyServiceId: '',
  step1: {
    formInitialValues,
    additionalDocuments: [],
  },

  // step2: {
  //   allDocuments: []
  // }
};
export const createDocumentFormValues = createDocumentFormInitialValues;

//End User Application Form
const initialApplicationValues = {
  documentURL: '',
  elements: [],
};
export const ApplicationFormInitialValues = {
  needResetForm: false,
  currentStep: 2,
  step1: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    address: '',
    city: '',
    state: '',
    postalcode: '',
    paymentAmount: 0,
    convenienceFee: 0,
    agencyServiceId: 0,
    additionalDocuments: [],
  },
  step2: {
    applicationValues: [],
  },
  base64Pdf: {},
  base64WebForm: '',
};
export const ApplicationFormValues = ApplicationFormInitialValues;

export const arrayInitial = [];
export const stringInitial = '';
export const objectInitial = { paymentsType: '' };
export const formatInitial = { documentsType: '' };
export const variableInitial = {};

//Admin
//Admin CRUD Form Values
export const AdminCRUDFormValues = {
  profileImage: '',
};

export const AgencyUserCrudValues = {
  profileImage: '',
};

export const formInitial = {
  formValues: [
    {
      uniqueId: Date.now().toString(),
      type: 'text',
      label: 'Field Label',
      placeholder: '',
      required: false,
      options: [
        { optionUniqueId: Date.now().toString(), label: '', value: '' },
      ],
      format: '',
      validationType: 'string',
      validations: [
        {
          type: 'required',
          params: ['Required'],
        },
      ],
      selectedValue: '',
      variableId: '',
      feesId: '',
      characterLimit: 10,
      allowPastDate: false,
    },
  ],
};

export const IntialType = [
  { value: 'text', type: 'Text Box' },
  { value: 'number', type: 'Number' },
  { value: 'textarea', type: 'Text Area' },
  { value: 'radio', type: 'Multiple Choice' },
  { value: 'checkbox', type: 'Checkboxes' },
  { value: 'select', type: 'Drop Down' },
  { value: 'date', type: 'Date' },
  { value: 'time', type: 'Time' },
  { value: 'variable', type: 'Variable' },
  { value: 'instruction', type: 'Instruction' },
  { value: 'maskedtextbox', type: 'Masked text Box' },
];

// {
// uniqueId: Date.now().toString(),
// validationType: 'string',
// validations: [
//   {
//     type: 'required',
//     params: ['Required'],
//   },
// ],
// selectedValue: '',
// },
export const InstructionInitial = {
  formValues: [],
};

export const commonListingInitial = {
  loading: true,
  totalCount: 0,
  list: [],
};

export const invoiceDetailInitial = {
  loading: true,
  detail: {},
  error: false,
};

export const couponDetailIntial = {
  loading: true,
  detail: {},
  error: false,
};
//Invoice form Initial
export const invoiceFormInitial = {
  couponId: 0,
  lineItems: [
    {
      uniqueId: shortid.generate(),
      invoiceItemId: 0,
      itemDescription: '',
      quantity: '',
      individualAmount: '',
      totalAmount: 0,
      isDeleted: false,
    },
  ],
  tax: 0,
  taxPercentage: 0,
  discount: 0,
  discountPercentage: 0,
  subTotal: 0,
  grandTotalAmount: 0,
  invoiceExpiryDate: '',
  paymentExpiryDate: '',
  memo: '',
  subscriptionid: '',
  locationCode: '',
};

export const initialArrayValues = {
  loading: false,
  data: [],
};
